// extracted by mini-css-extract-plugin
export default {"Link":"Header_Link__bAZHz","Brand":"Header_Brand__0Ezyu"};